import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const ManifestoChapters = () => {
  const { t } = useLang();
  return (
    <section data-testid="manifesto-section" className="bg-white py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Overline>{t.manifesto.overline}</Overline>
          <h2 className="mt-6 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900 max-w-2xl">
            {t.manifesto.title}
          </h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-2 border-t border-l border-slate-200">
          {t.manifesto.chapters.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div
                data-testid={`manifesto-chapter-${c.num}`}
                className="group h-full border-r border-b border-slate-200 p-10 lg:p-14 hover:bg-[#FAF9F6] transition-colors duration-500"
              >
                <span className="font-serif text-6xl lg:text-7xl font-bold text-slate-100 group-hover:text-emerald-100 transition-colors duration-500">
                  {c.num}
                </span>
                <h3 className="mt-6 text-xl lg:text-2xl font-medium text-slate-900">{c.title}</h3>
                <p className="mt-4 text-base text-slate-600 leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
